export interface IProgramStructure {
    stateCode: number;
    programId: string;
    name: string;
    isRequired: boolean;
    programRequirementId: string;
    semester: string;
    statusCode: number;
    courseNumber: string;
    // courseType?: number; // Uncomment if needed
    year: number;
    courseId?: string;
    blockValue: any;
    programVersionId: any;
    maxWeightedMarksTotal: any;
    listOfProgramSpecificOutcomes: any;
    registrationType: any;
    courseType?: number;
    modifiedOnBehalfBy: any;
    programSemester: any;
    maxRawScoreTotal: any;
    programLevelId: any;
    listOfProgramOutcomes: any;
    transcriptMarksTotal: any;
    academicSession: string;
    academicYear: string;
    remainingCapacity: number;
}

export interface ICourseHistory {
    courseHistoryId?: string;
    programId?: string;
    studentId?: string;
    semesterId?: string;
    yearNumber?: number;
    description?: string;
    sectionId?: string;
    courseCode?: string;
    electiveGroupCodeId?: string;
    registrationNumber?: string;
    rollNumber?: string;
    credit: number;
    yearId?: string;
    courseId?: string;
    courseName?: string;
    grades?: string;
    registrationStatusId?: string;
    registrationType?: number;
    courseType?: number;
    semesterClassification?: number;
    academicSession: string;
    academicYearId?: string;
}

export interface CourseHistoryReq {
    id?: string,
    courseName?: string;
    program?: string;
    studentId?: string;
    semester?: string;
    creditsAttempted?: number;
    semesterRegistrationId?: string;
    registrationType?: number;
    courseId?: string;
    academicPeriod?: string;
    academicYear?: string;
    courseType?: number;
}

export interface Course {
    name: string;
    credits: number;
    electiveGroupCode: string | null;
    description: string | null;
    courseId: string;
}
export interface ISemesterRegistration {
    odataEtag: string;
    registrationId: string;
    registrationStatus: string;
}

export enum ICourseType {
    Major = 365970000,
    OpenElective = 365970001,
    Elective = 365970002,
}
